// eslint-disable-next-line no-shadow
enum SenderType {
  CLIENT,
  SERVER,
  ROBOT,
}

export default SenderType;
